/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { CasCode } from '@/constants/casConventionCodes';

// Normalise un libellé pour une comparaison tolérante (casse, accents, espaces).
const normalizeLibelle = (value: unknown): string =>
  (value ?? '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    // Retire les diacritiques (plage combinante U+0300–U+036F).
    .replace(/[\u0300-\u036f]/g, '');

/**
 * Retrouve la clé numérique d'un champ codé de convention.
 *
 * Le GET renvoie le libellé (ex. « Convention-type PACS ») alors que la base
 * attend la clé : on convertit donc le libellé (ou une clé déjà numérique) vers
 * la clé correspondante. Toute valeur vide ou inconnue retombe sur `0`
 * (« Non renseigné »).
 */
const resolveCasCode = (cas: CasCode[], value: unknown): number => {
  const asNumber = Number(value);
  if (
    value !== null &&
    value !== '' &&
    !Number.isNaN(asNumber) &&
    cas.some((option) => option.value === asNumber)
  ) {
    return asNumber;
  }

  const target = normalizeLibelle(value);
  return (
    cas.find((option) => normalizeLibelle(option.text) === target)?.value ?? 0
  );
};

export default resolveCasCode;
